import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  formatAmount,
  List,
  SectionLabel,
  Spacer,
  StatCard,
  WideButton,
} from "@qivia/ui";
import { StyledColumn } from "@qivia/ui/src/designSystem/components/driverAppV2/layout";
import { AccountBalanceOutlined } from "@qivia/ui/src/designSystem/materialUi/materialUi";
import { HomeChargeRow } from "./homeChargeRow";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCompanyUuid } from "../../qrCode/vehicleLoginSlice";
import {
  getDriverChargesAsync,
  selectCharges,
  selectChargesStatus,
} from "../chargesSlice";
import { getReimbursementTotal } from "./lib";

export const Refunds = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const companyUuid = useAppSelector(selectCompanyUuid);
  const charges = useAppSelector(selectCharges);
  const chargesStatus = useAppSelector(selectChargesStatus);

  useEffect(() => {
    if (chargesStatus === "idle" && companyUuid) {
      void dispatch(getDriverChargesAsync({ companyUuid }));
    }
  }, [chargesStatus, companyUuid, dispatch]);

  const homeCharges = useMemo(
    () => charges.filter((charge) => charge.type === "HOME_CHARGING"),
    [charges],
  );

  const monthlyTotal = useMemo(() => {
    const now = new Date();
    return getReimbursementTotal(
      homeCharges.filter((charge) => {
        if (!charge.startAt) return false;
        const startAt = new Date(charge.startAt);
        return (
          startAt.getFullYear() === now.getFullYear() &&
          startAt.getMonth() === now.getMonth()
        );
      }),
    );
  }, [homeCharges]);
  const twoLastHomeCharges = useMemo(
    () => homeCharges.slice(0, 2),
    [homeCharges],
  );

  return (
    <StyledColumn>
      <SectionLabel>{t("appV2.refunds.thisMonth")}</SectionLabel>
      <Spacer y={1} />
      <StatCard
        icon={<AccountBalanceOutlined />}
        value={formatAmount(monthlyTotal)}
        unit="€"
        label={t("appV2.refunds.monthTotal")}
      />
      <Spacer y={2.5} />
      <List
        rows={twoLastHomeCharges.map((charge) => (
          <HomeChargeRow key={charge.uuid} charge={charge} />
        ))}
      />
      <Spacer y={2.5} />
      <WideButton
        label={t("appV2.refunds.historyButton")}
        onClick={() => navigate("/refunds_history")}
      />
      <Spacer y={1.5} />
    </StyledColumn>
  );
};
